import React, { useEffect, useState } from 'react';
import "./PaymentTab.css"
import { axiosGet } from '../../../../utils/apis/api';
import Cookies from "js-cookie";
import { Paginations, SpinnerLoading} from '../../../../components';
import PaymentCard from '../PaymentCard/PaymentCard';

const PaymentTab = () => {
  return (
    <div className=''>
      <PaymentCard
        serviceType={"Visa Service"}
        status={"Paid"}
        dateRange={"11 Nov 2025, 12:00 AM "}
        paymentMethod={"Bank Transfer"}
        price={"$578.2 "}
      >

      </PaymentCard>
      <PaymentCard
        serviceType={"Visa Service"}
        status={"Paid"}
        dateRange={"11 Nov 2025, 12:00 AM "}
        paymentMethod={"Bank Transfer"}
        price={"$578.2"}
      >

      </PaymentCard>
    </div>
  )
}

export default PaymentTab
